/**
 * @generated SignedSource<<b21045b4f6c8db52fd77f9ceba615f2f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CreateExternalLicensePoolInput = {
  clientMutationId?: string | null;
  data: ExternalLicensePoolDataInput;
};
export type ExternalLicensePoolDataInput = {
  link?: string | null;
  name: string;
  usageInformation: string;
  validNumDaysAfterIssuing: number;
};
export type externalLicensePoolsTable_CreateExternalLicensePoolMutation$variables = {
  connections: ReadonlyArray<string>;
  input: CreateExternalLicensePoolInput;
};
export type externalLicensePoolsTable_CreateExternalLicensePoolMutation$data = {
  readonly Admin: {
    readonly Billing: {
      readonly createExternalLicensePool: {
        readonly edge: {
          readonly node: {
            readonly id: string;
            readonly " $fragmentSpreads": FragmentRefs<"externalLicensePoolsTable_ExternalLicensePoolFragment">;
          };
        };
      } | null;
    };
  };
};
export type externalLicensePoolsTable_CreateExternalLicensePoolMutation = {
  response: externalLicensePoolsTable_CreateExternalLicensePoolMutation$data;
  variables: externalLicensePoolsTable_CreateExternalLicensePoolMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "canBeDeleted",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "ExternalLicensePoolData",
  "kind": "LinkedField",
  "name": "data",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "usageInformation",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "validNumDaysAfterIssuing",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "link",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "externalLicensePoolsTable_CreateExternalLicensePoolMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "BillingAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Billing",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v2/*: any*/),
                "concreteType": "CreateExternalLicensePoolPayload",
                "kind": "LinkedField",
                "name": "createExternalLicensePool",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ExternalLicensePoolsEdge",
                    "kind": "LinkedField",
                    "name": "edge",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ExternalLicensePool",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "kind": "InlineDataFragmentSpread",
                            "name": "externalLicensePoolsTable_ExternalLicensePoolFragment",
                            "selections": [
                              (v4/*: any*/),
                              (v3/*: any*/),
                              (v5/*: any*/)
                            ],
                            "args": null,
                            "argumentDefinitions": []
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "externalLicensePoolsTable_CreateExternalLicensePoolMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "BillingAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Billing",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v2/*: any*/),
                "concreteType": "CreateExternalLicensePoolPayload",
                "kind": "LinkedField",
                "name": "createExternalLicensePool",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ExternalLicensePoolsEdge",
                    "kind": "LinkedField",
                    "name": "edge",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ExternalLicensePool",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v4/*: any*/),
                          (v5/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "filters": null,
                    "handle": "appendEdge",
                    "key": "",
                    "kind": "LinkedHandle",
                    "name": "edge",
                    "handleArgs": [
                      {
                        "kind": "Variable",
                        "name": "connections",
                        "variableName": "connections"
                      }
                    ]
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "514b6d292b9f2e76130be1bcc363084c",
    "id": null,
    "metadata": {},
    "name": "externalLicensePoolsTable_CreateExternalLicensePoolMutation",
    "operationKind": "mutation",
    "text": "mutation externalLicensePoolsTable_CreateExternalLicensePoolMutation(\n  $input: CreateExternalLicensePoolInput!\n) {\n  Admin {\n    Billing {\n      createExternalLicensePool(input: $input) {\n        edge {\n          node {\n            id\n            ...externalLicensePoolsTable_ExternalLicensePoolFragment\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment externalLicensePoolsTable_ExternalLicensePoolFragment on ExternalLicensePool {\n  canBeDeleted\n  id\n  data {\n    name\n    usageInformation\n    validNumDaysAfterIssuing\n    link\n  }\n}\n"
  }
};
})();

(node as any).hash = "d7fdc6828fae3994c07e932d4465eb4e";

export default node;
